import { render, staticRenderFns } from "./ClientsInDebtPopup.vue?vue&type=template&id=a0659fc2&scoped=true&"
import script from "./ClientsInDebtPopup.vue?vue&type=script&lang=js&"
export * from "./ClientsInDebtPopup.vue?vue&type=script&lang=js&"
import style0 from "./ClientsInDebtPopup.vue?vue&type=style&index=0&id=a0659fc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0659fc2",
  null
  
)

export default component.exports